import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Login from "./pages/login";
import reportWebVitals from "./reportWebVitals";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  RouteProps,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Sidebar from "./components/Sidebar";
import Dashboard from "./pages/dashboard";
import Empresas from "./pages/empresas";
import AdicionarEmpresa from "./pages/empresas/cadastroEmpresa";
import Grupo from "./pages/grupo";
import AdicionarGrupo from "./pages/grupo/cadastroGrupo";
import Ferramenta from "./pages/ferramenta";
import AdicionarFerramenta from "./pages/ferramenta/cadastroFerramenta";
import Usuarios from "./pages/usuarios";
import AdicionarUsuario from "./pages/usuarios/cadastrarUsuario";
import Checklist from "./pages/checklist";
import Fabricante from "./pages/entrega/fabricante";
import AdicionarFabricante from "./pages/entrega/fabricante/cadastroFabricante";
import Modelo from "./pages/entrega/modelo";
import AdicionarModelo from "./pages/entrega/modelo/cadastroModelo";
import Tipo from "./pages/tipo";
import AdicionarTipo from "./pages/tipo/cadastroTipo";
import EditarEmpresa from "./pages/empresas/editarEmpresa";
import EditarFerramenta from "./pages/ferramenta/editarFerramenta";
import EditarUsuario from "./pages/usuarios/editarUsuario";
import EditarTipo from "./pages/tipo/editarTipo";
import EditarFabricante from "./pages/entrega/fabricante/editarFabricante";
import EditarModelo from "./pages/entrega/modelo/editarModelo";
import Acoes from "./pages/entrega/acoes";
import AdicionarAcao from "./pages/entrega/acoes/cadastroAcao";
import EditarAcao from "./pages/entrega/acoes/editarAcao";
import GruposPerguntas from "./pages/checklist/gruposPerguntas";
import Perguntas from "./pages/checklist/perguntas";
import Respostas from "./pages/checklist/respostas";
import TrasferirAcao from "./pages/entrega/transferirAcao";
import Veiculos from "./pages/veiculos";
import ChecklistBuilder from "./pages/checklist/builder";
import EditarChecklist from "./pages/checklist/EditarChecklist";
import GruposChecklist from "./pages/checklist/GruposChecklist";
import EditarGrupo from "./pages/checklist/EditarGrupo";
import EditarPergunta from "./pages/checklist/EditarPergunta";
import EditarResposta from "./pages/checklist/EditarResposta";
import NovoGrupo from "./pages/checklist/NovoGrupo";
import NovaPergunta from "./pages/checklist/NovaPergunta";
import NovaResposta from "./pages/checklist/NovaResposta";

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  return !!token;
};

const PrivateRoute: React.FC<RouteProps> = ({ children }) => {
  const location = useLocation();
  const authenticated = isAuthenticated();

  if (!authenticated) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

const App: React.FC = () => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      console.log(isOnline);
    };
  }, []);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status || 500;
        if (status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("userData");
          window.location.href = "/";
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Sidebar>
                <Dashboard />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/empresas"
          element={
            <PrivateRoute>
              <Sidebar>
                <Empresas />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarEmpresa"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarEmpresa />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarEmpresa/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarEmpresa />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/grupo"
          element={
            <PrivateRoute>
              <Sidebar>
                <Grupo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarGrupo"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarGrupo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/ferramenta"
          element={
            <PrivateRoute>
              <Sidebar>
                <Ferramenta />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarFerramenta"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarFerramenta />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarFerramenta/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarFerramenta />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/usuarios"
          element={
            <PrivateRoute>
              <Sidebar>
                <Usuarios />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarUsuario"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarUsuario />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarUsuario/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarUsuario />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/checklists"
          element={
            <PrivateRoute>
              <Sidebar>
                <Checklist />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarChecklist/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarChecklist />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/checklist/:id/grupos"
          element={
            <PrivateRoute>
              <Sidebar>
                <GruposChecklist  />
              </Sidebar>
            </PrivateRoute>
          }
        />
         <Route
          path="/editarChecklist/grupo/:grupoId"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarGrupo   />
              </Sidebar>
            </PrivateRoute>
          }
        />
         <Route
          path="/checklist/:id/grupos/novo"
          element={
            <PrivateRoute>
              <Sidebar>
                <NovoGrupo   />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarChecklist/pergunta/:perguntaId"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarPergunta  />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
           path="/editarChecklist/grupo/:grupoId/pergunta/novo"
          element={
            <PrivateRoute>
              <Sidebar>
                <NovaPergunta  />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarChecklist/resposta/:respostaId"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarResposta />
              </Sidebar>
            </PrivateRoute>
          }
        />
         <Route
          path="/editarChecklist/pergunta/:perguntaId/resposta/novo"
          element={
            <PrivateRoute>
              <Sidebar>
                <NovaResposta />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/checklist/builder"
          element={
            <PrivateRoute>
              <Sidebar>
                <ChecklistBuilder />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/checklist/:id/grupos"
          element={
            <PrivateRoute>
              <Sidebar>
                <GruposPerguntas />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/grupoPerguntas/:id/perguntas"
          element={
            <PrivateRoute>
              <Sidebar>
                <Perguntas />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/pergunta/:id/respostas"
          element={
            <PrivateRoute>
              <Sidebar>
                <Respostas />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/veiculos"
          element={
            <PrivateRoute>
              <Sidebar>
                <Veiculos />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/fabricantes"
          element={
            <PrivateRoute>
              <Sidebar>
                <Fabricante />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarFabricante"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarFabricante />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarFabricante/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarFabricante />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/modelos"
          element={
            <PrivateRoute>
              <Sidebar>
                <Modelo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarModelo"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarModelo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarModelo/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarModelo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/tipos"
          element={
            <PrivateRoute>
              <Sidebar>
                <Tipo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarTipo"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarTipo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarTipo/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarTipo />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/acoes"
          element={
            <PrivateRoute>
              <Sidebar>
                <Acoes />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/adicionarAcao"
          element={
            <PrivateRoute>
              <Sidebar>
                <AdicionarAcao />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/editarAcao/:id"
          element={
            <PrivateRoute>
              <Sidebar>
                <EditarAcao />
              </Sidebar>
            </PrivateRoute>
          }
        />
        <Route
          path="/acoesTrasnferir"
          element={
            <PrivateRoute>
              <Sidebar>
                <TrasferirAcao />
              </Sidebar>
            </PrivateRoute>
          }
        />
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
};

const rootElement = document.getElementById("root");
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(<App />);
} else {
  console.error('Elemento com ID "root" não encontrado.');
}

reportWebVitals();
